// components/schedule/ScheduleDialog/MemberSelectionDialog.tsx

import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Typography, Box
} from '@mui/material';
import { MemberSelectionDialogProps } from './types';
import { ScheduleMember } from '../../../types/schedule';
import { OtherScheduleMember } from '../../../types/otherSchedule';

export const MemberSelectionDialog: React.FC<MemberSelectionDialogProps> = ({
  open,
  onClose,
  members,
  currentMembers,
  onMemberSelect,
  membersWithOtherSchedules
}) => {
  // 現在選択されているメンバーIDの配列を取得
  const selectedMemberIds = (currentMembers as Array<ScheduleMember | OtherScheduleMember>)
    .filter((m: ScheduleMember | OtherScheduleMember) => m.Member_ID)
    .map((m: ScheduleMember | OtherScheduleMember) => m.Member_ID as number);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      disableRestoreFocus
    >
      <DialogTitle sx={{
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'grey.50',
        px: 3,
        py: 2
      }}>
        配川工業メンバー選択
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Grid container spacing={1.5}>
          {members
            .sort((a, b) => (a.ID ?? 0) - (b.ID ?? 0))
            .map((member) => {
              const isSelected = selectedMemberIds.includes(member.ID);
              const hasConflict = membersWithOtherSchedules.includes(member.ID);

              return (
                <Grid item xs={4} key={`company-${member.ID}`}>
                  <Button
                    fullWidth
                    variant={isSelected ? "contained" : "outlined"}
                    color={isSelected ? "success" : hasConflict ? "warning" : "primary"}
                    onClick={() => onMemberSelect(member)}
                    sx={{
                      height: '60px',
                      whiteSpace: 'normal',
                      lineHeight: 1.2,
                      textTransform: 'none',
                      ...(isSelected && {
                        fontWeight: 'bold',
                        boxShadow: 1,
                      }),
                      ...(hasConflict && !isSelected && {
                        borderStyle: 'dashed',
                        borderWidth: 2
                      }),
                    }}
                  >
                    <Box>
                      <Typography variant="body1">
                        {member.LastName}
                        {hasConflict && !isSelected && (
                          <Box component="span" sx={{ ml: 0.5, color: 'warning.main' }}>!</Box>
                        )}
                      </Typography>
                    </Box>
                  </Button>
                </Grid>
              );
            })}
        </Grid>
      </DialogContent>
      <DialogActions sx={{
        borderTop: 1,
        borderColor: 'divider',
        px: 3,
        py: 2
      }}>
        <Button
          onClick={onClose}
          variant="outlined"
        >
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};